import script from "./AppActionLogsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AppActionLogsView.vue?vue&type=script&setup=true&lang=js"

import "./AppActionLogsView.vue?vue&type=style&index=0&id=fe92c96c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe92c96c"]])

export default __exports__